import saMessages from '../locales/ja_JP.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  locale: 'ja-JP',
};
export default saLang;
